// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.tabContent{padding-left:400px;padding-right:400px}ul .nav .nav-tabs{padding-left:300px !important}.tab-nav{white-space:nowrap;width:300px !important}`, "",{"version":3,"sources":["webpack://./src/components/TradeSettlement/TradeSettlement.scss"],"names":[],"mappings":"AAAA,YAEI,kBAAA,CACA,mBAAA,CAGJ,kBACI,6BAAA,CAGJ,SACI,kBAAA,CACA,sBAAA","sourcesContent":[".tabContent {\n    // background-color: red !important;\n    padding-left: 400px;\n    padding-right: 400px;\n}\n\nul .nav .nav-tabs {\n    padding-left: 300px !important;\n}\n\n.tab-nav {\n    white-space: nowrap;\n    width: 300px !important;\n}"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"tabContent": `tabContent`,
	"nav": `nav`,
	"nav-tabs": `nav-tabs`,
	"tab-nav": `tab-nav`
};
export default ___CSS_LOADER_EXPORT___;
